import React, { useState } from "react"
import { Col, Modal, Row } from "react-bootstrap"
import { Button, Input } from "../../../components"
import { images } from "../../../config/images"
import { toast } from "react-toastify"
import { AssociateRescheduleAddBookingCourts, AssociateRescheduleAddBookingSlots, AssociateRescheduleCancelSlots, AssociateRescheduleDeleteCourt } from "../../../utilities/api/associateBooking"
import { GetCourtsAvailableForAssociateBooking, GetSlotsForAssociateBooking } from "../../../utilities/api/courts"
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.associateBooking;

const AssociateRescheduleEditModal = (props: any) => {
    const { showEditModal, handleCloseEdit, editSlotData, GetData, bookingDetails, StartDate } = props
    const [slotsList, setSlotsList] = useState([]) as any
    const [addSlot, setAddSlot] = useState([]) as any
    const [courtList, setCourtList] = useState([]) as any
    const [addCourt, setAddCourt] = useState([]) as any
    const [showDropdown, setShowDropdown] = useState(false)
    const [slotButton, setSlotButton] = useState(false)
    const [courtButton, setCourtButton] = useState(false)

    const GetSlots = async () => {
        let startDate = StartDate().split("/").reverse().join("-")
        let endDate = bookingDetails.endDate.split("/").reverse().join("-")

        const result = await GetSlotsForAssociateBooking(startDate, endDate, bookingDetails.facilityId, bookingDetails.sportId)
        if (result.statusCode === 200) {
            setSlotsList(result?.data?.timeSlots)
        }
    }

    const GetCourts = async () => {
        let payload = {
            facilityId: Number(bookingDetails.facilityId),
            sportId: Number(bookingDetails.sportId),
            startDate: StartDate().split("/").reverse().join("-"),
            endDate: bookingDetails.endDate.split("/").reverse().join("-"),
            slots: editSlotData?.groupedInnerSlots?.map((item: any) => ({
                sessionDay: editSlotData.bookingDay,
                startTime: item.fromTime,
                endTime: item.toTime
            }))
        }
        const result = await GetCourtsAvailableForAssociateBooking(payload)
        if (result.status === 200) {
            setShowDropdown(true)
            setCourtList(result.data.data.rows?.map((item: any) => ({
                labelKey: item.id,
                value: item.name
            })
            ))
            !result.data.data.rows.length && toast.error(getMessage.court_isUnavailable)
        }
    }

    const handleCancelSlot = async (item: any) => {
        let payload = {
            cancelType: "daywiseInner",
            bookingDay: editSlotData.bookingDay,
            startTime: item.fromTime,
            endTime: item.toTime,
            slotId: ""
        }
        let result = await AssociateRescheduleCancelSlots(bookingDetails.id, payload)
        if (result?.status === 200) {
            GetData()
            handleClose()
            toast.success(result?.data.message)
        } else {
            toast.error(result?.response.data.message);
        }
    }

    const handleCancelCourt = async (item: any) => {
        let payload = {
            bookingDay: editSlotData.bookingDay,
            startTime: editSlotData.startTime,
            endTime: editSlotData.endTime,
            courtId: item.courtId
        }
        let result = await AssociateRescheduleDeleteCourt(bookingDetails.id, payload)
        if (result?.status === 200) {
            GetData()
            handleClose()
            toast.success(result?.data.message)
        } else {
            toast.error(result?.response.data.message);
        }
    }

    const AddBookingSlots = async () => {
        setSlotButton(true)
        let _courts = editSlotData?.combinedCourts?.map((item: any) => item.courtId)
        let payload = {
            selectedSlots: addSlot.map((item: any) => (
                {
                    bookingDay: editSlotData.bookingDay,
                    startTime: item.fromTime,
                    endTime: item.toTime,
                    courts: _courts
                }
            ))
        }
        let _AddBookingSlots = await AssociateRescheduleAddBookingSlots(bookingDetails.id, payload)
        if (_AddBookingSlots?.status === 200) {
            GetData()
            handleClose()
            toast.success(_AddBookingSlots?.data.message)
        } else {
            toast.error(_AddBookingSlots?.response.data.message);
        }
        setSlotButton(false)
    }

    const AddBookingCourts = async () => {
        setCourtButton(true)
        let payload = {
            bookingDay: editSlotData.bookingDay,
            startTime: editSlotData.startTime,
            endTime: editSlotData.endTime,
            courts: addCourt
        }
        let _AddBookingCourts = await AssociateRescheduleAddBookingCourts(bookingDetails.id, payload)
        if (_AddBookingCourts?.status === 200) {
            GetData()
            handleClose()
            toast.success(_AddBookingCourts?.data.message)
        } else {
            toast.error(_AddBookingCourts?.response.data.message);
        }
        setCourtButton(false)
    }

    const handleChecked = (checked: boolean, data: any) => {
        checked
            ? setAddSlot([...addSlot, data])
            : setAddSlot(addSlot?.filter((item: any) => item.fromTime !== data.fromTime))
    }

    const handleChange = (value: any) => {
        setAddCourt(value.selectedKey)
    }

    const handleClose = () => {
        handleCloseEdit()
        setSlotsList([])
        setAddSlot([])
        setCourtList([])
        setAddCourt([])
        setShowDropdown(false)
    }

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter"
            centered show={showEditModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Selection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="slot-selection">
                    <Row className="text-start align-items-center row-mb">
                        <Col lg={6}>
                            <div className="fw-semibold">{editSlotData.bookingDay}: <span className="text-info">{editSlotData.startTime} to {editSlotData.endTime}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        <Col lg={6}>
                            <Row>
                                <Col lg={12} className="gx-4">
                                    <label htmlFor="" className="form-label">Booked Slots</label>
                                    <div className="available-slot d-flex flex-wrap gap-2">
                                        {editSlotData?.groupedInnerSlots?.map((item: any) => {
                                            return (
                                                <div
                                                    key={item.fromTime}
                                                    className="bg-light d-inline-block p-2 rounded-1 slot-box text-start mb-2 me-4"
                                                    style={{ maxWidth: "190px" }}
                                                >
                                                    <span className="d-block">
                                                        {item.fromTime} to {item.toTime}
                                                    </span>
                                                    <img
                                                        onClick={() => handleCancelSlot(item)}
                                                        src={images.deletesport.default}
                                                        width="19"
                                                        alt=""
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Col>
                                <div className="my-3">
                                    <Button onClick={GetSlots} type="button" bname="Add More Slots" name="add-more-slot" id="add-more-slot" className="btn btn-primary rounded-1" />
                                </div>
                                {slotsList.length > 0 && <>
                                    <label htmlFor="" className="form-label">Available Slots</label>
                                    <div className="overflow-auto mb-3" style={{ height: "245px" }}>
                                        <div className="available-slot d-flex flex-wrap gap-2">
                                            {slotsList.map((item: any, index: number) => {
                                                return (
                                                    <span style={{ width: '110px' }} key={"check" + index}>
                                                        <Input onChange={(e: any) => handleChecked(e.target.checked, item)}
                                                            checked={addSlot?.find((elem: any) => elem.fromTime === item.fromTime) ? true : false}
                                                            id={"slot" + index} type="checkbox" name={"slot" + index} className="btn-check" />
                                                        <label htmlFor={"slot" + index} className="bg-light bg-opacity-50 border border-2 btn btn-sm p-1 w-100">
                                                            <div className="slot-box text-start">
                                                                <span className="d-block">{item?.fromTime} to {item?.toTime}</span>
                                                                <span className="text-primary"><span className="rupees-symbol">&#8377;</span> {item?.ratePerSlot}</span>
                                                                {item?.discountPercent &&
                                                                    <>
                                                                        <del><span><span className="rupees-symbol">&#8377;</span> {item.actualRatePerSlot}</span></del>
                                                                    </>
                                                                }
                                                            </div>
                                                        </label>
                                                    </span>
                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                    <Modal.Footer>
                                        <Button disabled={addSlot.length <= 0 || slotButton} onClick={AddBookingSlots} type="button" bname={slotButton ? "Adding" : "Add Slots"} name="add-slots" id="add-slots" className="btn btn-primary rounded-1" />
                                    </Modal.Footer>
                                </>}
                            </Row>
                        </Col>
                        <Col lg={1} className="g-0 text-center">
                            <div className="vr h-100"></div>
                        </Col>
                        <Col lg={5}>
                            <Row className="g-0">
                                <Col lg={12}>

                                    <label htmlFor="" className="form-label">Booked Courts</label>
                                    <div className="available-slot d-flex flex-wrap gap-2">
                                        {editSlotData?.combinedCourts?.map((item: any) => {
                                            return (
                                                <div
                                                    key={item.id}
                                                    className="bg-light d-inline-block p-2 rounded-1 slot-box text-start mb-2 me-4"
                                                    style={{ maxWidth: "190px" }}>
                                                    <span className="d-block">{item.courtName}</span>
                                                    <img
                                                        onClick={() => handleCancelCourt(item)}
                                                        src={images.deletesport.default}
                                                        width="19"
                                                        alt=""
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Col>
                                <div className="my-3">
                                    <Button onClick={GetCourts} type="button" bname="Add More Courts" name="add-more-court" id="add-more-court" className="btn btn-primary rounded-1" />
                                </div>
                                {showDropdown && <>
                                    <div className="mb-3 text-start">
                                        <label htmlFor="courts" className="form-label">
                                            Select Court
                                        </label>
                                        <BootstrapSelect
                                            className="form-select-custom form-control"
                                            selectStyle=""
                                            actionBtnStyle="btn-outline-primary"
                                            options={courtList || []}
                                            isMultiSelect={true}
                                            showTick={true}

                                            showAction={true}
                                            placeholder="Select Courts"
                                            onChange={handleChange}

                                        />
                                    </div>

                                    <Modal.Footer>
                                        <Button disabled={addCourt.length <= 0 || courtButton} onClick={AddBookingCourts} type="button" bname={courtButton ? "Adding" : "Add Courts"} name="add-courts" id="add-courts" className="btn btn-primary rounded-1" />
                                    </Modal.Footer>

                                </>
                                }
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>

        </Modal>
    )
}

export { AssociateRescheduleEditModal }
